<template>
  <div class="mb-10">
    <v-progress-linear v-if="isLoading" indeterminate />

    <div v-if="notAnsweredYetAndUserIsAdminOrPartner && !emailNotSentOrInvalidStatus">
      <v-card class="confirm-appointment-message pa-5 d-flex justify-center" color="blue lighten-5" elevation="0">
        <span class="text-center blue--text">
          {{ $t('appointment.confirmAppointment.messages.adminOrPartnerAnswerConfirmationWarning') }}
        </span>
        <a @click="logout" class="text-center blue--text text-decoration-underline ml-1">
          {{ $t('appointment.confirmAppointment.messages.clickHere') }}
        </a>
      </v-card>
    </div>

    <div v-if="emailNotSentOrInvalidStatus">
      <v-card class="confirm-appointment-message pa-5" color="orange lighten-5" elevation="0">
        <span class="d-block text-center orange--text">
          {{ $t('appointment.confirmAppointment.messages.invalidStatus') }}
        </span>
      </v-card>
    </div>

    <div v-if="confirmed">
      <v-card class="confirm-appointment-message pa-5" color="success lighten-5" elevation="0">
        <span class="d-block text-center success--text">
          {{ $t('appointment.confirmAppointment.messages.alreadyConfirmed', { datetime: `${date} ${handleExecutionTime()}` }) }}
        </span>
      </v-card>
    </div>

    <div v-if="rejected">
      <v-card class="confirm-appointment-message pa-5" color="error lighten-5" elevation="0">
        <span class="d-block text-center error--text">
          {{ $t('appointment.confirmAppointment.messages.alreadyRejected') }}
        </span>
      </v-card>
    </div>
  </div>
</template>

<script>
import { logoutAndRefresh } from '@/services/auth/logout'
import moment from 'moment-timezone'
import { catalogDateWithoutTime, verifyTimePeriod } from '../../../util/catalog';

export default {
  name: 'ConfirmAppointmentMessages',

  props: {
    status: {
      type: String,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: false,
    },

    appointmentData: {
      type: Object,
      required: true,
    },

    isAdminOrPartner: {
      type: Boolean,
      required: true,
    },

    isEditingNewDate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logout: logoutAndRefresh
    }
  },

  computed: {
    date() {
      const date = this.confirmation.accepted_date ?? this.appointmentData?.date
      const timezoneDate = moment(date).tz(this.appointmentData?.timezone)
      return catalogDateWithoutTime(timezoneDate)
    },

    period() {
      return verifyTimePeriod(this.appointmentData?.date)
    },

    confirmation() {
      return this.appointmentData?.confirmation
    },

    notAnsweredYetAndUserIsAdminOrPartner() {
      return !this.isLoading && (this.confirmation && !this.confirmation.answered && this.isAdminOrPartner)
    },

    emailNotSentOrInvalidStatus() {
      return !this.isLoading && (this.status == 'CANCELED'
        || !this.confirmation
        || this.confirmation && !this.confirmation.sent_at && !this.confirmation.answered)
    },

    confirmed() {
      return !this.isLoading && !this.isEditingNewDate && this.confirmation && this.confirmation.answered && this.confirmation.confirmed
    },

    rejected() {
      return !this.isLoading && !this.isEditingNewDate && this.confirmation && this.confirmation.answered && !this.confirmation.confirmed
    },
  },

  methods: {
    handleExecutionTime() {
      const date = this.confirmation.accepted_date ?? this.appointmentData?.date
      const timezone = this.appointmentData?.timezone
      const startHour = moment(date).tz(timezone).format('hh:mm A')
      const slotSize = this.appointmentData.slot_size
      if (slotSize != 0) return `${this.$t('appointment.confirmAppointment.between')} ${startHour} - ${moment(startHour, 'hh:mm A').add(slotSize, 'minutes').format('hh:mm A')}`
      return `${this.$t('appointment.confirmAppointment.at')} ${startHour}`
    },
  },
}
</script>

<style scoped>
.confirm-appointment-message {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
</style>
